import { render, staticRenderFns } from "./SchoolNotification.vue?vue&type=template&id=47ebfe44&"
import script from "./SchoolNotification.vue?vue&type=script&lang=js&"
export * from "./SchoolNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports